import type { SipFund } from '../../../../api/common.types'
import { useOpenSipPlanRecommendationBottomSheet } from '../../../../plan-bottom-sheet/open/useOpenSipPlanRecommendationBottomSheet'
import { useSipPlansContext } from '../../../sipPlansContext'
import { showAsFormattedRupeeAmount } from '../../../../../display-values/lumpsumPlanAmount'
import { PlansFundCard } from '../../../../../lumpsum/plans-list/lumpsum-ui-components/PlansFundCard'
import { SipAmountBadge, SipFundCardActionLabel } from './sipYourPlanFundCardShared'
import { PlansFundRole, PlansScreen } from '../../../../../analytics/plansEvents'
import { trackPlansFundCardCta, trackPlansFundCardOpen } from '../../../../../analytics/plansTrack'

type NoActionSipFundCardProps = {
  fund: SipFund
  showBottomDivider?: boolean
}

export function NoActionSipFundCard({ fund, showBottomDivider = true }: NoActionSipFundCardProps) {
  const { plansOverview } = useSipPlansContext()
  const { openIdealSipPlanRecommendationBottomSheet } = useOpenSipPlanRecommendationBottomSheet()
  const totalIdealSipAmount = plansOverview?.totalIdealSipAmount ?? 0
  const isin = fund?.isin ?? ''
  const fundName = fund?.fundName ?? ''
  const screenName = PlansScreen.SipYourPlan
  const fundRole = PlansFundRole.NoAction
  const currentSipAmount = fund?.currentSipAmount ?? 0
  const formattedCurrentSip = showAsFormattedRupeeAmount({ rawAmount: currentSipAmount })

  const openPlanBottomSheet = () => {
    openIdealSipPlanRecommendationBottomSheet({ isin, totalIdealSipAmount })
  }

  const handleCardClick = () => {
    trackPlansFundCardOpen({ screenName, fundRole, fundName, fundIsin: isin })
    openPlanBottomSheet()
  }

  return (
    <PlansFundCard
      fund={{
        isin,
        logoUrl: fund?.mfLogoUrl ?? '',
        title: fundName,
        fundNature: fund?.fundNature ?? '',
        category: fund?.fundCategory ?? '',
        purchaseMode: fund?.purchaseMode ?? ''
      }}
      topRight={<SipFundCardActionLabel label="Continue SIP" />}
      badgeRowExtras={currentSipAmount > 0 ? <SipAmountBadge currentSipAmount={formattedCurrentSip} /> : null}
      status={{
        rank: fund?.powerRank ?? 0,
        rating: fund?.powerRating ?? ''
      }}
      ctas={[
        {
          id: `${isin}-no-change`,
          label: 'No action',
          onClick: () => {
            trackPlansFundCardCta({ screenName, fundRole, buttonLabel: 'No action', fundName, fundIsin: isin })
            console.log('No action', isin)
          },
          variant: 'completed'
        },
        {
          id: `${isin}-learn-more`,
          label: 'Learn more',
          onClick: () => {
            trackPlansFundCardCta({ screenName, fundRole, buttonLabel: 'Learn more', fundName, fundIsin: isin })
            openPlanBottomSheet()
          },
          variant: 'tertiary'
        }
      ]}
      showBottomDivider={showBottomDivider}
      onCardClick={handleCardClick}
    />
  )
}
